export const mapStyle = [
	{
		elementType: 'geometry',
		stylers: [{ color: '#1E1E1E' }],
	},
	{
		elementType: 'labels.text.stroke',
		stylers: [{ color: '#1E1E1E' }],
	},
	{
		elementType: 'labels.text.fill',
		stylers: [{ color: '#B3B3B3' }],
	},
	{
		featureType: 'administrative.locality',
		elementType: 'labels.text.fill',
		stylers: [{ color: '#B3B3B3' }],
	},
	{
		featureType: 'administrative',
		elementType: 'geometry.stroke',
		stylers: [{ color: '#353535' }],
	},
	{
		featureType: 'road',
		elementType: 'geometry',
		stylers: [{ color: '#353535' }],
	},
	{
		featureType: 'road.highway',
		elementType: 'geometry',
		stylers: [{ color: '#353535' }],
	},
	{
		featureType: 'road',
		elementType: 'labels',
		stylers: [{ visibility: 'off' }],
	},
	{
		featureType: 'water',
		elementType: 'geometry',
		stylers: [{ color: '#000000' }],
	},
	{
		featureType: 'poi',
		stylers: [{ visibility: 'off' }],
	},
	{
		featureType: 'transit',
		stylers: [{ visibility: 'off' }],
	},
	{
		featureType: 'poi.business',
		stylers: [{ visibility: 'off' }],
	},
	{
		featureType: 'poi.attraction',
		stylers: [{ visibility: 'off' }],
	},
	{
		featureType: 'poi.medical',
		stylers: [{ visibility: 'off' }],
	},
	{
		featureType: 'poi.school',
		stylers: [{ visibility: 'off' }],
	},
];